import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { CheckCircle2, ArrowRight, FileText } from "lucide-react";

export default function DelegaSuccesso() {
  const [params] = useSearchParams();
  const scaricate = Number(params.get("scaricate") || 0);
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-16">
        <CheckCircle2 className="mx-auto text-[#2D5A47]" size={56}/>
        <h1 className="font-serif-display text-4xl text-center mt-4 text-[#1E3F33]" data-testid="delega-success-title">
          Delega attivata
        </h1>
        <p className="mt-3 text-center text-[#2C2C2C] leading-relaxed">
          Perfetto: IVA Radar è ora collegato al tuo Cassetto Fiscale. Da oggi le tue fatture verranno scaricate e aggiornate automaticamente.
        </p>

        {scaricate > 0 && (
          <div className="mt-8 card-flat p-5 flex items-center gap-4">
            <FileText className="text-[#C25934]" size={28}/>
            <div>
              <div className="font-serif-display text-2xl text-[#1E3F33]">{scaricate} fatture</div>
              <div className="text-sm text-[#6B6B6B]">già sincronizzate dagli ultimi mesi</div>
            </div>
          </div>
        )}

        <div className="mt-8 card-flat p-6 bg-white">
          <h3 className="font-serif-display text-xl text-[#1E3F33]">Cosa succede ora</h3>
          <ol className="mt-3 space-y-2 text-sm text-[#2C2C2C]">
            <li className="flex gap-2"><span className="font-medium text-[#C25934]">1.</span> Ogni giorno controlliamo il tuo cassetto per nuove fatture.</li>
            <li className="flex gap-2"><span className="font-medium text-[#C25934]">2.</span> Ricevi la stima IVA aggiornata direttamente nel cruscotto.</li>
            <li className="flex gap-2"><span className="font-medium text-[#C25934]">3.</span> Se il saldo supera la tua soglia, ti avvisiamo via email.</li>
          </ol>
        </div>

        <div className="mt-8 text-center">
          <Link to="/dashboard" data-testid="delega-goto-dashboard" className="btn-lift inline-flex items-center gap-2 px-6 py-3 bg-[#1E3F33] text-white rounded-md hover:bg-[#152D24]">
            Vai al cruscotto <ArrowRight size={16}/>
          </Link>
        </div>
      </div>
    </div>
  );
}
